__turbopack_context__.v({
  "card": "HowItWorks-module__vXgQdG__card",
  "cardContainer": "HowItWorks-module__vXgQdG__cardContainer",
  "description": "HowItWorks-module__vXgQdG__description",
  "heading": "HowItWorks-module__vXgQdG__heading",
  "imgContainer": "HowItWorks-module__vXgQdG__imgContainer",
  "para": "HowItWorks-module__vXgQdG__para",
  "root": "HowItWorks-module__vXgQdG__root",
  "tag": "HowItWorks-module__vXgQdG__tag",
  "text": "HowItWorks-module__vXgQdG__text",
  "title": "HowItWorks-module__vXgQdG__title",
});
